import type { Props } from '../../definition'

export default async (p: Props, username?: string, password?: string) => {
	if (!username || !password) {
		log.error('Username or password cannot be empty')
		return false
	}

	const db = R.surreal?.db
	if (!db) {
		R.libs.mantine?.MantineError?.('Ошибка авторизации!', 'Нет подключения к SurrealDB', 5000)
		return false
	}

	const startTime = log.start()
	try {
		const token = await db.signin({
			namespace: p.surrealDbNamespace || 'default',
			database: p.surrealDbDatabase || 'data',
			access: p.surrealAuthAccessMethod || 'default',
			variables: {
				login: username,
				password,
			},
		})

		// Сохраняем токен
		await R.db.states.auth.set('token', () => token)

		log.end('SurrealDB sign in', startTime)
		return true
	} catch (e: any) {
		R.libs.mantine?.MantineError?.('Ошибка авторизации!', 'Неверный логин или пароль', 2000)
		log.error('SurrealDB sign in failed', e.message)
		return false
	}
}
